import type { IPrimaryHeaderProps } from '../../../../interfaces/globals';

import './PrimaryHeader.scss';

const PrimaryHeader = ({ title, children, className }: IPrimaryHeaderProps) => {
  const rootClass = ['primary-header', className].filter(Boolean).join(' ');
  return (
    <header className={rootClass}>
      <span className="primary-header__title">{title}</span>
      {children !== undefined && <div className="primary-header__actions">{children}</div>}
    </header>
  );
};

export default PrimaryHeader;
